export interface AsyncState<P> {
  isLoading: boolean;
  isFetched: boolean;
  hasError: boolean;
  payload: P;
}

// @TODO Omit is in new version of TS
// type Options<S> = Partial<Omit<AsyncState<S>, 'payload'>>;
interface Options<S> {
  isLoading: boolean;
  isFetched: boolean;
  hasError: boolean;
}

export const createAsyncState = <S>(state: S, options?: Partial<Options<S>>) => ({
  isLoading: false,
  isFetched: false,
  hasError: false,
  ...options,

  payload: state,
});

export const asyncState = <S extends AsyncState<any>, P>(
  mapFn?: (mapP: P, state?: S) => Pick<S, 'payload'>,
  options?: Options<S>,
) => (state: S, payload?: P): S => ({
  ...state,
  ...options,

  ...(mapFn ? mapFn(payload, state) : {}),
});

export const asyncStart = <S extends AsyncState<any>, P>(
  mapFn?: (mapP: P, state?: S) => Pick<S, 'payload'>,
  options?: Options<S>,
) => asyncState(mapFn, { isLoading: true, ...options });

export const asyncSuccess = <S extends AsyncState<any>, P>(
  mapFn?: (mapP: P, state?: S) => Pick<S, 'payload'>,
  options?: Options<S>,
) => asyncState(mapFn, { isLoading: false, isFetched: true, hasError: false, ...options });

export const asyncFailed = <S extends AsyncState<any>, P>(
  mapFn?: (mapP: P, state?: S) => Pick<S, 'payload'>,
  options?: Options<S>,
) => asyncState(mapFn, { isLoading: false, hasError: true, ...options });
